import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZiroButtonComponent } from '../../button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReleaseNotesModalComponent } from './release-notes-modal.component';
import { ReleaseNotesService } from './release-notes.service';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [ReleaseNotesModalComponent],
  exports: [ReleaseNotesModalComponent],
  imports: [CommonModule, ZiroButtonComponent, TranslateModule, PipesModule],
  providers: [ReleaseNotesService],
})
export class ReleaseNotesModule {}
